import styled, { keyframes } from 'styled-components';
import { COLORS } from '../../styles/variables';

interface StyleProps {
  size: number | undefined;
}

const spin = keyframes`
  to { transform: rotate(360deg) }
`;

// eslint-disable-next-line import/prefer-default-export
export const StyledSpinner = styled.div<{ size?: number; filterSpinner?: boolean }>`
  display: inline-block;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  border: ${({ filterSpinner }) =>
    filterSpinner ? `3px solid ${COLORS.grey70}` : '3px solid rgba(0, 0, 0, 0.1)'};
  border-radius: 50%;
  border-top-color: ${({ filterSpinner }) => (filterSpinner ? COLORS.white : COLORS.audiRed)};
  animation: ${spin} 1s ease-in-out infinite;
`;
